import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import th from 'vee-validate/dist/locale/th';

// loop over all rules
for (let rule in rules) {
    extend(rule, {
        ...rules[rule], // add the rule
        message: th.messages[rule] // add its message
    });
}
extend('timeshipping', {
    validate: value => {
        var arr = []
        arr = value.split(':')
        if (arr.length && arr.length == 2) {
            var hour = parseInt(arr[0])
            if (hour > 12 && hour < 16) {
                return true
            } else {
                return false
            }

        } else {

            return true;
        }
    },
    message: 'สามารถเลือกเวลาได้ตั้งแต่ 13.00-15.00 น.'
});

extend('isUrl', value => {
    var pattern = new RegExp(
        /^(ftp|http|https|line):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
    ) // fragment locator
    return pattern.test(value)
})